<template>
	<g transform="translate(-41.521996,-44.372993)">
		<ellipse
			ry="97.359001"
			rx="100.21"
			cy="141.73199"
			cx="141.73199"
			:fill="getButtonColor ? getButtonColor : '#ffffff'"
		/>
		<polygon
			points="124.672,122.594 158.793,141.732 124.672,160.872 "
			:fill="getButtonColor ? '#fff' : '#ef4e5e'"
		/>
	</g>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('tour', ['getButtonColor'])
    }
  };
</script>
